export enum BlogUrlQueries {
  SORT = '_s',
  YEAR = '_year',
  MONTH = '_month',
}
